import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import './footer.scss';

// Asset import
import Visa from '../../assets/img/footer/visa.png';
import Amex from '../../assets/img/footer/amex.png';
import SafeKey from '../../assets/img/footer/safeKey.png';
import MasterCard from '../../assets/img/footer/masterCard.png';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';

// map the redux states to props
function mapStateToProps(state) {
    return {
        loadingScreenVisible: state.loadingScreen
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen
};

class ExternalFooter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subscribeMail: "",
        }
    }

    render() {
        return (<div className="footer-container">
            <div className="external-footer-links">
                <Col xs="12" md={{ span: 10, offset: 1 }}>
                    <Row className="m-0 align-items-center">
                        <Col lg="2" md="3" xs="12" className="footer-link-top-row-item">
                            <img className="img-fluid" src={KeellsLogo}></img>
                        </Col>
                        <Col lg="auto" md="12" sm="12" xs="12" className="footer-link-top-row-item external-footer-center-text">
                            <div>Jaykay Marketing Services Pvt Ltd.<br />No:148, Vauxhall Street, Colombo 2, Sri Lanka.</div>
                        </Col>
                        <Col lg="auto" md="12" sm="12" xs="12" className="footer-link-top-row-item">
                            <div className="footer-phone-number-holder"><i className="fas fa-phone"></i>+94 11 2303500</div>
                        </Col>
                        <Col className="footer-link-top-row-item">
                            <div>(Daily operating hours 8.00a.m to 8.00p.m)</div>
                        </Col>
                        <Col lg="auto" md="12" sm="12" xs="12" className="footer-link-top-row-item footer-link-social-link-holder pr-0 d-flex justify-content-end">
                            <div className="social-link-without-design">
                                <a href="https://www.facebook.com/Keells.SL/" target="_blank"  >
                                    <div className="footer-link-social-link"><i className="fab fa-facebook-f" ></i></div>
                                </a>
                                <a href="https://twitter.com/keells_sl" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-twitter"></i></div>
                                </a>
                                <a href="https://www.youtube.com/channel/UCCu17kGGZjuVITjK4Z_0N0g" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-youtube"></i></div>
                                </a>
                            </div>
                        </Col>
                        <Col lg="12" md="12" sm="12" xs="12" className="footer-link-top-row-item footer-link-social-link-holder">
                            <div className="social-link-design">
                                <a href="https://www.facebook.com/Keells.SL/" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-facebook-f" ></i></div>
                                </a>
                                <a href="https://twitter.com/keells_sl" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-twitter"></i></div>
                                </a>
                                <a href="https://www.youtube.com/channel/UCCu17kGGZjuVITjK4Z_0N0g" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-youtube"></i></div>
                                </a>
                            </div>
                        </Col>

                    </Row>

                </Col>
            </div>
            <div className="footer-bottom">
                <Col xs="12" md={{ span: 10, offset: 1 }}>
                    <Row className="m-0 align-items-center">
                        <Col lg="auto" md="12" xs="12">
                            Copyright © {new Date().getFullYear()} Jaykay Marketing Services (Pvt) Ltd. All Rights Reserved
                        </Col>
                        <Col lg="auto" md="12" xs="12" className="ml-auto footer-payment-method-holder">
                            <img className="img-fluid footer-payment-method-image" src={Visa}></img>
                            <img className="img-fluid footer-payment-method-image" src={MasterCard}></img>
                            <img className="img-fluid footer-payment-method-image" src={Amex}></img>
                            <img className="img-fluid" src={SafeKey}></img>
                        </Col>
                    </Row>
                </Col>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalFooter);